import React from 'react'
import { createRoot } from 'react-dom/client'

import WorkstreamsApp from './app'

window.initWorkstreamsApp = (container, params) => {
  const root = createRoot(container);

  root.render(
    <WorkstreamsApp
      {...params}
    />,
  );
};

export { WorkstreamsTabPortals } from './tab-listeners';
